<div class="row product-list-item-doc">

  <!-- LEFT COLUMN -->
  <div class="col-xs-5 col-md-5">
    <label
      class="product-code"
      [innerHTML]="product.softwareTitle | searchHighlight: searchQuery">
    </label>

    <label
      class="doc-type"
      [innerHTML]="product.softwareGroup | searchHighlight: searchQuery">
    </label>

    <label
      class="doc-type"
      [innerHTML]="product.packageType | searchHighlight: searchQuery">
    </label>

    <label
      class="doc-type"
      [innerHTML]="product.softwareType | searchHighlight: searchQuery">
    </label>

    <label
      class="doc-type mt-2"
      [innerHTML]="product.softwareDescription | searchHighlight: searchQuery">
    </label>
  </div>

  <!-- MIDDLE COLUMN -->
  <div class="col-xs-4 col-md-3">
    <label class="fs-14">{{'common.text_software_search_lang_lable'|cxTranslate}}
      <span [innerHTML]="product.softwareLanguage |searchHighlight:searchQuery"></span></label>

      <label class="fs-14"><span>{{'common.text_software_search_version_lable'|cxTranslate}}</span>
      <span [innerHTML]="product.softwareVersion |searchHighlight:searchQuery"></span></label>

      @if (product?.releaseDate) {
        <label class="fs-14"><span>{{'common.document_text_releaseDate'|cxTranslate}}</span>
        <span [innerHTML]="product.releaseDate |searchHighlight:searchQuery"></span></label>
      }

    </div>

    <div class="col-xs-3 col-md-4">
      @if (product.softwareRegistration ) {
        <a class="btn btn-primary btn-block fs-20 btn-download" [routerLink]="['/softwareRequest']"
          [queryParams]="{code:product.softwareCode}">
          {{'common.text_software_search_button_download_lable'|cxTranslate}}
          <img class = "hover-img whiteArrow" src="/icons/link-grey.svg">
        </a>
      } @else {
        <a class="btn btn-primary btn-block fs-20 btn-download" target="_blank" [href]="product?.softwareURL">
          {{'common.text_software_search_button_download_lable'|cxTranslate}}
          <img class = "hover-img" src="/icons/link-grey.svg" width="20px"></a>
        }
        <a class='btn btn-sub-primary btn-block fs-20' [routerLink]="['/softwareDetailsPage']"
        [queryParams]="{code:product.softwareCode}">{{'common.text_software_search_button_viewdetails_lable'|cxTranslate}}</a>
      </div>

    </div>
